import { render, staticRenderFns } from "./StorageCategoryPathLabel.vue?vue&type=template&id=f3ee164e&scoped=true&"
import script from "./StorageCategoryPathLabel.vue?vue&type=script&lang=ts&"
export * from "./StorageCategoryPathLabel.vue?vue&type=script&lang=ts&"
import style0 from "./StorageCategoryPathLabel.vue?vue&type=style&index=0&id=f3ee164e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ee164e",
  null
  
)

export default component.exports